

















import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {Company} from '@/interfaces/company.interface';
import CompanyService from '@/services/api/company.service';
import {VALIDATION_RULES} from '@/helpers/helpers';

@Component
export default class CompanyAutocomplete extends Vue {
  @Prop({default: 'Company'}) label!: string;
  @Prop({default: false}) required?: boolean;

  loading = false;
  selectedCompany: (string | Company) = '';
  input = null;
  items = [];
  searchTimer: number = 0;
  searchDelay = 200;
  requiredFieldRules = VALIDATION_RULES.required;
  COMBO_BOX_REF_NAME: string = 'combobox';

  @Prop({default: ''}) value!: string;


  // TODO: Commented out for now as seems that autocomplete has been fixed with Vuetify v2?
  // mounted() {
  //   this.fixVuetifyAutocompleteBug();
  // }
  //
  // private fixVuetifyAutocompleteBug() {
  //   const componentElement: Vue = this.$refs[this.COMBO_BOX_REF_NAME] as Vue;
  //   const inputElement = componentElement.$el.querySelector('input');
  //   inputElement && inputElement.setAttribute('autocomplete', 'chrome-off');
  // }

  @Emit('input')
  private companyNameUpdated() {
    return this.selectedCompany;
  }

  @Emit('company-updated')
  companyUpdated(): Company {
    return this.selectedCompany as Company;
  }

  @Watch('value')
  updateValue(val: string) {
    this.selectedCompany = val;
  }

  @Watch('input')
  doSearch(val: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      val && val !== this.selectedCompany && this.querySelections(val);
    }, this.searchDelay);
  }

  @Watch('selectedCompany')
  selectedCompanyUpdated() {
    if (this.selectedCompany && this.selectedCompany.hasOwnProperty('name')) {
      this.companyUpdated();
    } else {
      this.companyNameUpdated();
    }
  }

  private async querySelections(val: string) {
    this.loading = true;
    const encodedVal = encodeURI(val).replace('/', '%2F');
    this.items = await CompanyService.search(encodedVal);
    this.loading = false;
  }

}
